export default __webpack_public_path__ + "images/df484026ddd02a2ab2125684ebcfcf28.svg";